export var ColorPropsEnum;
(function (ColorPropsEnum) {
  ColorPropsEnum["black"] = "#000000";
})(ColorPropsEnum || (ColorPropsEnum = {}));
//# sourceMappingURL=types.js.map